// @core/api/endpoints/chat/update_conversation_member_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ConversationMemberResponse,
  UpdateConversationMemberRoleRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Update member role
 * Changes the role of a conversation member, affecting their permissions to manage the conversation and its members.
 */
export async function UpdateConversationMemberRole(
  conversation_id: string,
  profile_id: string,
  data: UpdateConversationMemberRoleRequest,
  options?: RequestOptions
): Promise<ConversationMemberResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/members/:profile_id/role`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.put<ConversationMemberResponse>(requestPath, data, requestOptions);
}
